import React from "react";
import { Link } from "react-router-dom";

const articles = [
  {
    id: 1,
    title: "Understanding the Vouch System",
    slug: "understanding-vouch-system",
  },
  // Adicione mais artigos conforme necessário
];

const BlogHome = () => {
  return (
    <div className="blog-home">
      <h1>Blog</h1>
      <ul>
        {articles.map((article) => (
          <li key={article.id}>
            <Link to={`/blog/${article.slug}`}>{article.title}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogHome;
